// extracted by mini-css-extract-plugin
export default {"table_plots":"PlotSubobjective_table_plots__ePwL-","td_plots":"PlotSubobjective_td_plots__ytSjW"};